// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__2lX_i","logo":"menu_logo__3qyPn","menu__links":"menu_menu__links__P-bOp","search__dropdown":"menu_search__dropdown__1N2xl"};